export type AppLanguage = "de" | "en";
export type AppCurrency = "EUR" | "USD" | "CHF";

const LOCALE_KEY = "dwik-locale";
const CURRENCY_KEY = "dwik-currency";

export const SUPPORTED_LANGUAGES: AppLanguage[] = ["de", "en"];
export const SUPPORTED_CURRENCIES: AppCurrency[] = ["EUR", "USD", "CHF"];

export function defaultCurrencyForLanguage(lang: AppLanguage): AppCurrency {
  return lang === "en" ? "USD" : "EUR";
}

export function detectLanguage(): AppLanguage {
  if (typeof localStorage !== "undefined") {
    const stored = localStorage.getItem(LOCALE_KEY);
    if (stored === "de" || stored === "en") return stored;
  }

  const langs =
    typeof navigator !== "undefined"
      ? (navigator.languages?.length
          ? navigator.languages
          : [navigator.language])
      : [];

  for (const raw of langs) {
    const code = raw.split("-")[0]?.toLowerCase();
    if (code === "de") return "de";
    if (code === "en") return "en";
  }

  return "de";
}

export function detectCurrency(lang: AppLanguage): AppCurrency {
  if (typeof localStorage !== "undefined") {
    const stored = localStorage.getItem(CURRENCY_KEY);
    if (
      stored === "EUR" ||
      stored === "USD" ||
      stored === "CHF"
    ) {
      return stored;
    }
  }
  return defaultCurrencyForLanguage(lang);
}

export function saveLanguage(lang: AppLanguage): void {
  localStorage.setItem(LOCALE_KEY, lang);
}

export function saveCurrency(currency: AppCurrency): void {
  localStorage.setItem(CURRENCY_KEY, currency);
}

export function intlLocaleForLanguage(lang: AppLanguage): string {
  return lang === "en" ? "en-US" : "de-DE";
}
